export const MuiSlider = {
    styleOverrides: {
        root: {
            '.MuiSlider-thumb': {
                top: '50%',
                transform: 'translate(-50%, -50%)',
            }
        }
    }
}
